import { createContext, useContext, useMemo } from 'react';
import { WebsocketDeskPhoneEventSubscription } from '@frontend/calls-v2';
import { useHasConnectedSoftphone } from '@frontend/phone-config';
import { useWeaveWebsocketConnection } from '../utils/websocket-connection';
import { useAllWebsocketEventSubscriptions } from './use-all-websocket-event-subscriptions';

type ContextValue = ReturnType<typeof useWeaveWebsocketConnection>;

const WebsocketContext = createContext<ContextValue>({} as ContextValue);

export const WebsocketSubscriptionsProvider = ({ children }: { children: React.ReactNode }) => {
  const hasSoftphone = useHasConnectedSoftphone();
  const { websocket, websocketState, retry, subscribe, isSubscribed, subscribedLocations } =
    useWeaveWebsocketConnection();

  useAllWebsocketEventSubscriptions();

  const value = useMemo(() => {
    return {
      websocket,
      websocketState,
      isSubscribed,
      subscribedLocations,
      retry,
      subscribe,
    };
  }, [websocket, websocketState, isSubscribed, subscribe, subscribedLocations, retry]);

  return (
    <WebsocketContext.Provider value={value}>
      {!hasSoftphone && <WebsocketDeskPhoneEventSubscription />}
      {children}
    </WebsocketContext.Provider>
  );
};

export const useWebsocketContext = () => {
  return useContext(WebsocketContext);
};
